export const MpxAllowedDomains = ['feed.entertainment.tv.theplatform.eu'];

export enum MpxProgramType {
    Series = 'series',
    Movie = 'movie',
    Episode = 'episode',
}

export enum MpxTagScheme {
    Categories = 'Categories',
    Genre = 'Genre',
}
